let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jyfmA")).then(() => parcelRequire('dZrxI'));